export default __webpack_public_path__ + "src/assets/crowded-block.7c43de4b1693215e635a77c37771cd19.svg";